/**
 * Deterministic name → palette colour. Lives in `lib/` (not the chip
 * component) so React Fast Refresh can swap the chip without losing
 * picker state, and so non-component code (e.g. label dropdown
 * indicators) can reuse the same palette.
 *
 * Renaming a label changes its colour (intentional — colour follows
 * the name). Same name = same colour everywhere; different names
 * tend to map to different palette entries.
 */

const _PALETTE: ReadonlyArray<{ bg: string; fg: string }> = [
  { bg: "#fce7e6", fg: "#991e1e" }, // red
  { bg: "#fff0d4", fg: "#9a5705" }, // orange
  { bg: "#fff8b8", fg: "#7a5b00" }, // yellow
  { bg: "#dff7d4", fg: "#1b6f1f" }, // green
  { bg: "#cfeed7", fg: "#0e7a52" }, // teal
  { bg: "#cfecfa", fg: "#0e5a8a" }, // blue
  { bg: "#dde1ff", fg: "#383b96" }, // indigo
  { bg: "#e9d8ff", fg: "#5d2799" }, // purple
  { bg: "#fbd0e7", fg: "#9a1f5e" }, // pink
  { bg: "#f4d3c7", fg: "#7a3d1c" }, // brown
  { bg: "#d8e4ec", fg: "#3a4d5c" }, // gray-blue
  { bg: "#e3e7d6", fg: "#4f573b" }, // olive
];

/** djb2-XOR hash of the name, modulo palette length. */
export function labelColorIndex(name: string): number {
  let h = 5381;
  for (let i = 0; i < name.length; i++) {
    h = ((h << 5) + h) ^ name.charCodeAt(i);
  }
  return Math.abs(h) % _PALETTE.length;
}

export function labelColors(name: string): { bg: string; fg: string } {
  return _PALETTE[labelColorIndex(name)]!;
}
